export default __webpack_public_path__ + "static/media/modal_image.c6be4ffe.png";